import { Record } from 'immutable';
import UserViewRecord from './UserViewRecord';
const SearchResultRecordFactoryBase = Record({
  contentId: null,
  contentType: null,
  createdAt: null,
  description: null,
  documentId: null,
  docLink: null,
  folderId: null,
  id: null,
  lastUsedAt: null,
  metadata: null,
  name: null,
  portalId: null,
  publicationStage: null,
  shortcut: null,
  updatedAt: null,
  userId: null,
  userView: UserViewRecord()
}, 'SearchResultRecord');
const SearchResultRecord = SearchResultRecordFactoryBase;
SearchResultRecord.init = searchResult => {
  const contentType = searchResult.get('contentType');
  const contentId = searchResult.get('contentId');
  return SearchResultRecord(searchResult.set('id', `${contentType}_${contentId}`));
};
SearchResultRecord.initFromJS = resultJSON => {
  return SearchResultRecord.init(SearchResultRecord(resultJSON));
};
export default SearchResultRecord;